import {
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  deleteOrder: [],
  error: {},
}

const deleteOrder = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELETE_ORDER_SUCCESS:
      return {
        ...state,
        deleteOrder: action.payload,
      }

    case DELETE_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default deleteOrder
